<template>
  <div>
    <form @reset="onReset" class="item-editor-form">
      <fg-input
        v-model="form.uniqueId"
        :label="$t('sse_displays.uniqueid')"
        :disabled="disabled"
      ></fg-input>
      <fg-input
        v-model="form.name"
        :label="$t('sse_displays.name')"
        :disabled="disabled"
      ></fg-input>

      <b-row>
        <b-col
          ><fg-input
            v-model="form.location.latitude"
            :label="$t('sse_displays.lat')"
            :disabled="disabled"
          ></fg-input
        ></b-col>
        <b-col
          ><fg-input
            v-model="form.location.longitude"
            :label="$t('sse_displays.lon')"
            :disabled="disabled"
          ></fg-input
        ></b-col>
      </b-row>
      <label for="organisaatio">{{ $t('device_view.organisation') }}</label>
      <organisationSelect v-model="form.organisaatio" id="organisaatio" />

      <div v-for="parameter in parameters" :key="parameter.name">
        <fg-input
          v-if="parameter.type == 'text'"
          :label="$t('sse_displays.parameters.' + parameter.name)"
          v-model="form.configuration[parameter.name]"
          :disabled="disabled"
        />
        <div v-if="parameter.type == 'select'">
          <label>{{ $t('sse_displays.presentationState') }}</label>
          <vSelect
            :options="selectOptions(parameter.validValues)"
            v-model="itemOrganParams[parameter.name]"
            :reduce="(item) => item.val"
            :clearable="false"
          />
        </div>
      </div>
      <div v-if="action == 'edit'">
        <div
          v-for="orgDevParameter in organizationDeviceParameters"
          :key="orgDevParameter.id"
        >
          <div v-if="orgDevParameter.name === 'timetable_view_id'">
            <TimetableViewSelect
              v-model="itemOrganParams[orgDevParameter.name]"
              :disabled="disabled"
            />
          </div>
          <div v-else-if="orgDevParameter.type === 'BOOLEAN'">
            <label>{{ $t(orgDevParameter.descriptionId) }}</label>
            <b-form-checkbox
              value="true"
              unchecked-value="false"
              v-model="itemOrganParams[orgDevParameter.name]"
              :disabled="disabled"
            />
          </div>
          <div v-else-if="orgDevParameter.type === 'SELECT'">
            <label>{{ $t(orgDevParameter.descriptionId) }}</label>

            <vSelect
              v-model="itemOrganParams[orgDevParameter.name]"
              :options="orgDevParameter.validValues"
              :disabled="disabled"
            >
              <template v-slot:selected-option="selected">
                {{ $t(selected.descriptionId) }}
              </template>
              <template v-slot:item="item">
                {{ $t(item.descriptionId) }}
              </template>
              <template v-slot:option="option">
                {{ $t(option.descriptionId) }}
              </template>
            </vSelect>
          </div>
          <div v-else>
            <fg-input
              v-bind:label="$t(orgDevParameter.descriptionId)"
              v-model="itemOrganParams[orgDevParameter.name]"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <FormButtons
        @submit="onSubmit"
        :submit="$UIPrivilegeU('devices/ssedisplays')"
        :reset="false"
        :remove="action == 'edit' && $UIPrivilegeD('devices/ssedisplays')"
        @remove="remove"
        :disableSubmit="loading"
        :disableRemove="disabled || loading"
      />

      <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
    <DeleteModal
      :itemid="selectedDisplay ? selectedDisplay.uniqueId : ''"
      @ok="onDeleteOK"
    />
  </div>
</template>

<script>
import sseDisplay from '@/store/displays/sseDisplay'
import device from '@/store/displays/device'
import vSelect from 'vue-select'
import organisationSelect from '@/components/Timetable/OrganisationSelect'
import TimetableViewSelect from '@/components/Content/Timetables/TimetableViewSelect'

export default {
  name: 'SseDisplayEditForm',
  components: {
    vSelect,
    organisationSelect,
    TimetableViewSelect,
  },
  props: {
    item: {
      default: null,
      attributes: {},
    },
    action: { default: 'new' },
  },
  data: function () {
    return {
      disabled: false,
      defaultFormData: {
        uniqueId: null,
        name: null,
        location: {
          latitude: null,
          longitude: null,
        },
        organization: null,
        configuration: {},
      },
      form: {
        uniqueId: null,
        name: null,
        location: {
          latitude: null,
          longitude: null,
        },
        organization: null,
        configuration: {},
      },
      ok: false,
      error: false,
      loading: false,
      infoType: 'save',
      itemOrganParams: {},
    }
  },
  mounted: function () {
    if (this.$store.state.device) {
      this.$store
        .dispatch(
          'device/getOrganizationDeviceParameters',
          this.item.organisaatio
        )
        .catch(() => {
          // Error handling?
        })
    }
  },
  computed: {
    resetDisabled() {
      return this.form.uniqueId == null
    },
    selectedDisplay() {
      return this.item
    },
    inputChanged() {
      if (this.selectedDisplay) {
        let configurationChanged = false
        for (const p of this.$store.state.sseDisplay.sseDisplayParameterList) {
          if (
            this.form.configuration[p.name] !=
            this.selectedDisplay.configuration[p.name]
          ) {
            configurationChanged = true
            break
          }
        }
        let deviceChanged =
          this.form.location.latitude !=
            this.selectedDisplay.location.latitude ||
          this.form.location.longitude !=
            this.selectedDisplay.location.longitude
        return (
          deviceChanged ||
          configurationChanged ||
          this.form.uniqueId != this.selectedDisplay.uniqueId ||
          this.form.name != this.selectedDisplay.name
        )
      }
      return true
    },
    parameters() {
      return this.$store.state.sseDisplay.sseDisplayParameterList
    },
    organizationDeviceParameters() {
      return this.$store.state.device.organizationDeviceParameters.list
    },
  },
  watch: {
    item() {
      this.ok = this.error = this.loading = this.disabled = false
      this.copyItemData()
      this.makeOrganParamObject(this.form.attributes)
    },
  },
  methods: {
    newDisplay() {
      this.form = Object.assign({}, this.defaultFormData)
      this.disabled = false
    },
    onSubmit(event) {
      if (event) event.preventDefault()

      this.form.configuration = this.makeOrganParamArray()
      this.ok = this.error = false
      this.infoType = 'save'
      this.loading = this.disabled = true

      this.$store
        .dispatch('sseDisplay/saveDisplay', this.form)
        .then((response) => {
          setTimeout(() => {
            this.ok = response.data.errorCode == 0
            this.error = !this.ok
            this.loading = this.disabled = false
          }, 1000)
        })
        .catch(() => {
          this.error = true
        })
        .finally()
    },
    onReset(event) {
      event.preventDefault()
      this.$store.commit('sseDisplay/changeSelectedDisplay', null)
      this.form = this.defaultFormData
      this.disabled = true
    },
    remove() {
      this.$bvModal.show('delete-modal')
    },
    onDeleteOK() {
      this.infoType = 'delete'
      this.loading = this.disabled = true
      this.$store
        .dispatch('sseDisplay/deleteDisplay', this.selectedDisplay.deviceId)
        .then((response) => {
          setTimeout(() => {
            this.ok = response.data.errorCode == 0
            this.error = !this.ok
            this.loading = false
          }, 1000)
        })
    },
    copyItemData() {
      if (this.item) {
        this.form = JSON.parse(JSON.stringify(this.item))
      }
    },
    selectOptions(options) {
      return options.map((a) => {
        let selectItem = {}
        selectItem.val = a
        selectItem.label = this.$t(`sse_displays.presentationStateValues.${a}`)
        return selectItem
      })
    },
    makeOrganParamObject: function (pArray) {
      if (!pArray) return
      let paramObj = {}
      pArray.forEach((i) => {
        if (
          i.value.toLowerCase() === 'true' ||
          i.value.toLowerCase() === 'false'
        ) {
          paramObj[i.name] = i.value.toLowerCase() === 'true'
        } else {
          paramObj[i.name] = i.value
        }
      })

      this.itemOrganParams = paramObj
      return paramObj
    },
    makeOrganParamArray: function () {
      let rArray = []
      for (let [key, value] of Object.entries(this.itemOrganParams)) {
        let entryValue = value
        if (typeof value === 'object' && value != null) entryValue = value.value
        let entry = {}
        entry.name = key
        entry.value = '' + entryValue
        rArray.push(entry)
      }
      return rArray
    },
  },
  beforeCreate: function () {
    if (!this.$store.state.sseDisplay) {
      this.$store.registerModule('sseDisplay', sseDisplay)
    }
    if (!this.$store.state.device) {
      this.$store.registerModule('device', device)
    }
    this.$store.dispatch('sseDisplay/getDisplayParameterList')
  },
  created() {
    this.ok = this.error = this.loading = this.disabled = false
    this.copyItemData()
    this.makeOrganParamObject(this.form.attributes)
  },
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
</style>
